export default __webpack_public_path__ + "static/media/headset6.2a43db6a.jfif";